/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreditPackage
 */
export interface CreditPackage {
    /**
     * Unique identifier for the credit package
     * @type {string}
     * @memberof CreditPackage
     */
    id: string;
    /**
     * Display name of the credit package
     * @type {string}
     * @memberof CreditPackage
     */
    name: string;
    /**
     * Number of credits included in the package
     * @type {number}
     * @memberof CreditPackage
     */
    credits: number;
    /**
     * Price of the package in USD
     * @type {number}
     * @memberof CreditPackage
     */
    price: number;
    /**
     * Whether this package is marked as popular
     * @type {boolean}
     * @memberof CreditPackage
     */
    popular: boolean;
    /**
     * Apple App Store product ID for in-app purchases (iOS only)
     * @type {string}
     * @memberof CreditPackage
     */
    appleProductId?: string;
}

/**
 * Check if a given object implements the CreditPackage interface.
 */
export function instanceOfCreditPackage(value: object): value is CreditPackage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('credits' in value) || value['credits'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('popular' in value) || value['popular'] === undefined) return false;
    return true;
}

export function CreditPackageFromJSON(json: any): CreditPackage {
    return CreditPackageFromJSONTyped(json, false);
}

export function CreditPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditPackage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'credits': json['credits'],
        'price': json['price'],
        'popular': json['popular'],
        'appleProductId': json['appleProductId'] == null ? undefined : json['appleProductId'],
    };
}

  export function CreditPackageToJSON(json: any): CreditPackage {
      return CreditPackageToJSONTyped(json, false);
  }

  export function CreditPackageToJSONTyped(value?: CreditPackage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'credits': value['credits'],
        'price': value['price'],
        'popular': value['popular'],
        'appleProductId': value['appleProductId'],
    };
}

